var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "live-drop" }, [
    _c("div", { staticClass: "tab-box" }, [
      _c(
        "button",
        {
          staticClass: "live",
          class: { active: _vm.drop_type == 0 },
          attrs: { value: "live" },
          on: {
            click: function ($event) {
              return _vm.switchType(0)
            },
          },
        },
        [_c("div", { staticClass: "icon" }), _vm._v("LIVE ")]
      ),
      _c(
        "button",
        {
          staticClass: "top",
          class: { active: _vm.drop_type == 1 },
          attrs: { value: "top" },
          on: {
            click: function ($event) {
              return _vm.switchType(1)
            },
          },
        },
        [
          _c("div", { staticClass: "icon", attrs: { fill: "#606062" } }, [
            _c(
              "svg",
              {
                attrs: {
                  viewBox: "0 0 12 12",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("g", { attrs: { "clip-path": "url(#shared-star-id-a)" } }, [
                  _c("path", {
                    attrs: {
                      d: "M11.97 4.6a.64.64 0 0 0-.55-.44l-3.46-.31L6.59.65a.64.64 0 0 0-1.18 0l-1.37 3.2-3.46.31a.64.64 0 0 0-.36 1.12l2.62 2.3-.78 3.4a.64.64 0 0 0 .95.69L6 9.88l2.99 1.79a.64.64 0 0 0 .95-.7l-.78-3.4 2.62-2.29c.2-.17.27-.43.19-.68Z",
                      fill: "#606062",
                    },
                  }),
                ]),
                _c("defs", [
                  _c("clipPath", { attrs: { id: "shared-star-id-a" } }, [
                    _c("path", { attrs: { fill: "#fff", d: "M0 0h12v12H0z" } }),
                  ]),
                ]),
              ]
            ),
          ]),
          _vm._v("TOP "),
        ]
      ),
    ]),
    _vm.best_item && _vm.isGameTypeVisible(_vm.best_item)
      ? _c("div", { staticClass: "best-drop" }, [
          _c("div", { staticClass: "award-item raritybest" }, [
            _vm._m(0),
            _c("div", { staticClass: "user-info-con" }, [
              _c("div", { staticClass: "mask" }),
              _c("div", { staticClass: "user-info" }, [
                _c("div", { staticClass: "case-con" }, [
                  _c("div", { staticClass: "case" }, [
                    _c("div", { staticClass: "case-pic" }, [
                      _vm.best_item.gameType == 0
                        ? _c("img", {
                            attrs: {
                              src: _vm._f("imgfilter")(_vm.best_item.casePic),
                            },
                          })
                        : _vm._e(),
                      _vm.best_item.gameType == 1
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/icons/upgrade.png"),
                            },
                          })
                        : _vm._e(),
                      _vm.best_item.gameType == 4
                        ? _c("img", {
                            attrs: {
                              src: require("@/assets/icons/battle_60x60.png"),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "user" }, [
                  _c("div", { staticClass: "avatar-con" }, [
                    _c("div", { staticClass: "avatar" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.best_item.avatar
                            ? _vm.$imgfilter(_vm.best_item.avatar)
                            : require("@/assets/images/user/ava_none.jpg"),
                        },
                      }),
                    ]),
                  ]),
                  _c("span", { staticClass: "username" }, [
                    _vm._v(_vm._s(_vm.best_item.nickname)),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "award-shadow" }),
            _vm._m(1),
            _c("div", { staticClass: "award-pic-box" }, [
              _c("img", {
                attrs: { src: _vm._f("imgfilter")(_vm.best_item.item.itemPic) },
              }),
            ]),
            _c("div", { staticClass: "award-text" }, [
              _c("div", { staticClass: "name" }, [
                _c("div", { staticClass: "name-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("GetItemName")(_vm.best_item.item.name))
                  ),
                ]),
                _c("div", { staticClass: "skin-text" }, [
                  _vm._v(
                    _vm._s(_vm._f("GetItemSkinName")(_vm.best_item.item.name))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "rarity-text" }, [
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("GetItemDuration")(_vm.best_item.item.name)
                      ) +
                      " "
                  ),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "drop-item-con" }, [
      _c(
        "div",
        {
          staticClass: "item-list live",
          class: { active: _vm.drop_type == 1 },
        },
        _vm._l(_vm.livefeed_items, function (item, index) {
          return _c(
            "div",
            {
              key: _vm.livefeed_index(index),
              staticClass: "award-item",
              class: "rarity" + item.item.rarity,
              on: {
                click: function ($event) {
                  return _vm.on_cases_opened_click(item)
                },
              },
            },
            [
              _vm._m(2, true),
              _c("div", { staticClass: "user-info-con" }, [
                _c("div", { staticClass: "mask" }),
                _c("div", { staticClass: "user-info" }, [
                  _c("div", { staticClass: "case-con" }, [
                    _c("div", { staticClass: "case" }, [
                      _c("div", { staticClass: "case-pic" }, [
                        item.gameType == 0
                          ? _c("img", {
                              attrs: { src: _vm._f("imgfilter")(item.casePic) },
                            })
                          : _vm._e(),
                        item.gameType == 1
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/icons/upgrade.png"),
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "user" }, [
                    _c("div", { staticClass: "avatar-con" }, [
                      _c("div", { staticClass: "avatar" }, [
                        _c("img", {
                          attrs: {
                            src: item.avatar
                              ? _vm.$imgfilter(item.avatar)
                              : require("@/assets/images/user/ava_none.jpg"),
                          },
                        }),
                      ]),
                    ]),
                    _c("span", { staticClass: "username" }, [
                      _vm._v(_vm._s(item.nickname)),
                    ]),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "tips" }, [
                _c(
                  "div",
                  { staticClass: "icon-box" },
                  [
                    item.gameType == 1
                      ? _c("c-svg", {
                          staticClass: "icon",
                          staticStyle: { width: "9px" },
                          attrs: { src: "upgrade.svg" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "award-pic-box" }, [
                _c("img", {
                  attrs: {
                    width: "100%",
                    src: _vm._f("imgfilter")(item.item.itemPic),
                  },
                }),
              ]),
              _c("div", { staticClass: "award-text" }, [
                _c("div", { staticClass: "name" }, [
                  _c("div", { staticClass: "name-text" }, [
                    _vm._v(_vm._s(_vm._f("GetItemName")(item.item.name))),
                  ]),
                  _c("div", { staticClass: "skin-text" }, [
                    _vm._v(_vm._s(_vm._f("GetItemSkinName")(item.item.name))),
                  ]),
                ]),
                _c("div", { staticClass: "rarity-text" }, [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("GetItemDuration")(item.item.name)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "item-list top", class: { active: _vm.drop_type == 1 } },
        _vm._l(_vm.livefeed_top_items, function (item, index) {
          return _c(
            "div",
            {
              key: _vm.livefeed_top_index(index),
              staticClass: "award-item",
              class: "rarity" + item.item.rarity,
              on: {
                click: function ($event) {
                  return _vm.on_cases_opened_click(item)
                },
              },
            },
            [
              _vm._m(3, true),
              _c("div", { staticClass: "user-info-con" }, [
                _c("div", { staticClass: "mask" }),
                _c("div", { staticClass: "user-info" }, [
                  _c("div", { staticClass: "case-con" }, [
                    _c("div", { staticClass: "case" }, [
                      _c("div", { staticClass: "case-pic" }, [
                        item.gameType == 0
                          ? _c("img", {
                              attrs: { src: _vm._f("imgfilter")(item.casePic) },
                            })
                          : _vm._e(),
                        item.gameType == 1
                          ? _c("img", {
                              attrs: {
                                src: require("@/assets/icons/upgrade.png"),
                              },
                            })
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "user" }, [
                    _c("div", { staticClass: "avatar-con" }, [
                      _c("div", { staticClass: "avatar" }, [
                        _c("img", {
                          attrs: {
                            src: item.avatar
                              ? _vm.$imgfilter(item.avatar)
                              : require("@/assets/images/user/ava_none.jpg"),
                          },
                        }),
                      ]),
                    ]),
                    _c("span", { staticClass: "username" }, [
                      _vm._v(_vm._s(item.nickname)),
                    ]),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "tips" },
                [
                  item.gameType == 1
                    ? _c("c-svg", {
                        staticClass: "icon",
                        attrs: { src: "upgrade.svg" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("div", { staticClass: "award-pic-box" }, [
                _c("img", {
                  attrs: {
                    width: "100%",
                    src: _vm._f("imgfilter")(item.item.itemPic),
                  },
                }),
              ]),
              _c("div", { staticClass: "award-text" }, [
                _c("div", { staticClass: "name" }, [
                  _c("div", { staticClass: "name-text" }, [
                    _vm._v(_vm._s(_vm._f("GetItemName")(item.item.name))),
                  ]),
                  _c("div", { staticClass: "skin-text" }, [
                    _vm._v(_vm._s(_vm._f("GetItemSkinName")(item.item.name))),
                  ]),
                ]),
                _c("div", { staticClass: "rarity-text" }, [
                  _c("span", { staticClass: "text" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("GetItemDuration")(item.item.name)) +
                        " "
                    ),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shine" }, [
      _c("img", { attrs: { src: require("@/assets/images/shine.gif") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tips" }, [
      _c("div", { staticClass: "icon-box" }, [
        _c("img", { attrs: { src: require("@/assets/icons/Vector.png") } }),
        _c("div", { staticClass: "text" }, [_vm._v("近期最佳!")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shine" }, [
      _c("img", { attrs: { src: require("@/assets/images/shine.gif") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "shine" }, [
      _c("img", { attrs: { src: require("@/assets/images/shine.gif") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }